import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import styles from './PublicBookingSuccess.module.css'
import IconHome from '../../assets/icons/IconHome.svg'
import IconCalendar from '../../assets/icons/IconCalendar.svg'
import IconUser from '../../assets/icons/IconUser.svg'
import IconInfoStroke from '../../assets/icons/IconInfoStroke.svg'
import IconCheck from '../../assets/icons/SuccessBooking.svg'
import { useAppSelector } from '../../redux/types/types'

const PublicBookingSuccess = () => {
  const bookingData = useSelector((state: RootState) => state.bookingTabs.bookingData)

  const { items: publicOrderItems } = useAppSelector((state) => state.publicOrder)

  const formatDateRange = (startDate: string, endDate: string): string => {
    try {
      const start = new Date(startDate)
      const end = new Date(endDate)

      const formatDate = (date: Date): string => {
        const day = date.getDate().toString().padStart(2, '0')
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const year = date.getFullYear()
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')

        return `${day}.${month}.${year}, ${hours}:${minutes}`
      }

      return `${formatDate(start)} - ${formatDate(end)}`
    } catch (error) {
      console.error('Ошибка форматирования даты:', error)
      return `${startDate} - ${endDate}`
    }
  }

  return (
    <div className={styles.publicBookingSuccess}>
      <div className={styles.header}>
        <img src={IconCheck} alt='IconCheck' />
        <h1 className={styles.title}>Зал успешно забронирован!</h1>
      </div>
      <div className={styles.container}>
        <div className={styles.topBlock}>Бронирование</div>
        <div className={styles.content}>
          <div className={styles.item}>
            <img src={IconHome} alt='IconHome' />
            <div className={styles.itemContent}>
              <div className={styles.itemTitle}>Место проведения</div>
              <div className={styles.itemValue}>
                Зал: {bookingData?.place?.name || 'Название места не указано'}
              </div>
              <div className={styles.itemValue}>
                Адрес: {bookingData?.place?.address || bookingData?.city || 'Адрес не указан'}
              </div>
            </div>
          </div>
          <div className={styles.item}>
            <img src={IconCalendar} alt='IconCalendar' />
            <div className={styles.itemContent}>
              <div className={styles.itemTitle}>Детали бронирования</div>
              <div className={styles.itemValue}>
                {bookingData?.startDate && bookingData?.endDate
                  ? formatDateRange(bookingData.startDate, bookingData.endDate)
                  : 'Дата и время не указаны'}
              </div>
              <div className={styles.itemValue}>
                Дополнительные услуги:{' '}
                {publicOrderItems.length > 0
                  ? publicOrderItems.map((item) => item.name).join(', ')
                  : 'Дополнительные услуги не выбраны'}
              </div>
            </div>
          </div>
          <div className={styles.item}>
            <img src={IconUser} alt='IconUser' />
            <div className={styles.itemContent}>
              <div className={styles.itemTitle}>Количество гостей</div>
              <div className={styles.itemValue}>
                {bookingData?.peopleCount || 'Не указано'} человек
              </div>
            </div>
          </div>
          <div className={styles.item}>
            <img src={IconInfoStroke} alt='IconInfoStroke' />
            <div className={styles.itemContent}>
              <div className={styles.itemTitle}>Ваши данные</div>
              <div className={styles.itemValue}>
                Контактное лицо:{' '}
                {bookingData?.bookingType === 'Физическое лицо'
                  ? bookingData?.fullName || 'ФИО не указано'
                  : bookingData?.contactPerson || 'Контактное лицо не указано'}
              </div>
              <div className={styles.itemValue}>
                Телефон: {bookingData?.phone || 'Телефон не указан'}
              </div>
              <div className={styles.itemValue}>
                Почта: {bookingData?.email || 'Электронная почта не указана'}
              </div>
              {bookingData?.bookingType === 'Юридическое лицо' && (
                <>
                  <div className={styles.itemValue}>
                    Организация: {bookingData?.organizationName || 'Не указано'}
                  </div>
                  <div className={styles.itemValue}>ИНН: {bookingData?.inn || 'Не указан'}</div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PublicBookingSuccess
